<template>
  <section class="border border-gray-300 mt-4 p-4 rounded-md">
    <div class="flex items-center">
      <input
        type="checkbox"
        name='videoControls'
        v-model="element.videoControls"
        class="h-4 w-4 text-blue-400 focus:ring-blue-400 border-gray-300 rounded"
      />
      <label for="videoControls" class="ml-2 block text-sm text-gray-500">
        Enable controls?
      </label>
    </div>
  </section>
</template>

<script>
// import Component from "../component_location"
// import EPinPosition from "./EPinPosition.vue";
// import EPinDuration from "./EPinDuration.vue";

export default {
  // components: { EPinPosition, EPinDuration },

  props: {
    type: { type: String, default: "image" },
    element: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>

